import React from 'react'
import PropTypes from 'prop-types'
import { Grid, GridItem } from '../grid'
import css from './style.css'
import DiamondDetails from '../diamond-details'
import ItemHeader from '../item-header'
import DiamondPhoto from '../diamond-photo'
import Price from '../price'

const SummaryDiamond = props => (
  <Grid>
    <GridItem col='2/10'>
      {<DiamondPhoto small firstImageURL={props.diamond['Image URL']} summary />}
    </GridItem>
    <GridItem col='7/10'>
      <ItemHeader type='diamond' data={props.diamond} index={props.index} />
      <DiamondDetails data={props.diamond} />
    </GridItem>
    <GridItem col='1/10'>
      <Price price={props.price} styleClass={css.price} />
    </GridItem>
  </Grid>
)

SummaryDiamond.propTypes = {
  diamond: PropTypes.object.isRequired
}

export default SummaryDiamond



// WEBPACK FOOTER //
// ./src/components/summary-diamond/index.js